export const state = {
  purchases: [],
  purchase_receiving_item: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchases/state.js